import "../css/Footer.css"

const Footer = ({companyName = 'ООО «З Квадрат»'}) => {

    let FooterDate = (new Date()).getFullYear()

    return <div id="FooterInternal">
        &copy; {FooterDate} {companyName}
    </div>
}

export default Footer